<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="m11.258 12.666 1.642-1.641 2.675-2.675c.558-.567.158-1.534-.642-1.534H5.067c-.8 0-1.2.967-.634 1.534l4.317 4.316a1.775 1.775 0 0 0 2.508 0"
	/>
</svg>
